/**
 * Clickable event timeline. Clicking a timestamp seeks the video player.
 */
import React from 'react';

function parseTimestamp(ts) {
  const parts = String(ts).split(':').map(Number);
  if (parts.some(Number.isNaN)) return 0;
  if (parts.length === 3) return parts[0] * 3600 + parts[1] * 60 + parts[2];
  if (parts.length === 2) return parts[0] * 60 + parts[1];
  return parts[0] || 0;
}

export default function Timeline({ items = [], onSeek, importanceKey }) {
  if (!items.length) {
    return <p className="text-gray-400 text-sm">No timeline events available.</p>;
  }

  return (
    <ol className="relative border-l border-gray-200 ml-2 space-y-6">
      {items.map((item, idx) => (
        <li key={idx} className="ml-4">
          <span className="absolute -left-[7px] w-3 h-3 rounded-full bg-brand-600 border-2 border-white" />
          <button
            type="button"
            onClick={() => onSeek && onSeek(parseTimestamp(item.timestamp))}
            className="text-brand-600 font-mono text-sm hover:underline"
          >
            {item.timestamp}
          </button>
          {importanceKey && item[importanceKey] && (
            <span
              className={`ml-2 text-xs px-2 py-0.5 rounded-full ${
                item[importanceKey] === 'high'
                  ? 'bg-red-100 text-red-700'
                  : item[importanceKey] === 'medium'
                  ? 'bg-yellow-100 text-yellow-700'
                  : 'bg-gray-100 text-gray-600'
              }`}
            >
              {item[importanceKey]}
            </span>
          )}
          <p className="text-gray-700 text-sm mt-1">{item.event || item.description}</p>
        </li>
      ))}
    </ol>
  );
}
